/**
 * Common validation utilities
 */

/**
 * Validate email format
 * Allows @, ., + and standard email characters
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if valid email format
 */
export const validateEmail = (email) => {
  if (!email) return false;
  // Allow @, ., + and standard email characters
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

/**
 * Format job title to proper case
 * Converts qa-engineer to QA Engineer, backend-developer to Backend Developer, etc.
 * @param {string} title - Job title to format
 * @returns {string} - Formatted job title
 */
export const formatJobTitle = (title) => {
  if (!title) return '';
  // Replace hyphens and underscores with spaces, then capitalize each word
  return title
    .replace(/[-_]+/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Validate phone number (max 13 digits)
 * @param {string} phoneNumber - Phone number to validate
 * @returns {boolean} - True if valid
 */
export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return true; // Allow empty
  const digitsOnly = phoneNumber.replace(/[^\d]/g, '');
  return digitsOnly.length <= 13;
};

/**
 * Validate string length
 * @param {string} value - String to validate
 * @param {number} maxLength - Maximum allowed length
 * @returns {boolean} - True if valid
 */
export const validateMaxLength = (value, maxLength) => {
  if (!value) return true;
  return value.length <= maxLength;
};

